import {LoaderFunctionArgs} from 'react-router-dom';
import {runInAction} from 'mobx';
import {getAppTracer} from '../../../app.tracer';
import {NwayParticipantState} from './NwayParticipantState';
import {IParticipantStore, ParticipantStore} from './participant.stores';

const trace = getAppTracer('participant.loader');

export async function participantRouteLoader(args: LoaderFunctionArgs): Promise<IParticipantStore> {
    trace.info('Starting');

    const url = new URL(args.request.url);

    const state = new NwayParticipantState();

    runInAction(() => {
        state.guid = url.searchParams.get('g') || '';
        state.isMini = !!url.searchParams.get('mini');
        state.isEmb = !!url.searchParams.get('emb');
    });

    const store = new ParticipantStore(state);

    await store.initStore();

    trace.info('Completed successfully');

    return store;
}
